import { render } from "./FiltersView.vue?vue&type=template&id=189a9a22"
import script from "./FiltersView.vue?vue&type=script&lang=js"
export * from "./FiltersView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__